const { default: axiosIns } = require('@/libs/axios')

const APIKeysService = {
  // GET - APIKeyApiController
  async getAPIKeys(accountId, page, searchTerm) {
    return axiosIns.get(`/keys/list/${page}/${searchTerm}?accountId=${accountId}`).then(response => response.data)
  },
  async revoke(model, accountId) {
    return axiosIns.get(`/keys/revoke/${model.id}?accountId=${accountId}`).then(response => response.data)
  },
  async regenerate(model, accountId) {
    return axiosIns.get(`/keys/regenerate/${model.id}?accountId=${accountId}`).then(response => response.data)
  },
  // POST - APIKeyApiController
  async saveAPIKey(model, accountId) {
    return axiosIns.post(`/keys?accountId=${accountId}`, model).then(response => response.data)
  },
  // DELETE - APIKeyApiController
  async delete(model, accountId) {
    return axiosIns.delete(`/keys/?id=${model.id}&accountId=${accountId}`).then(response => response.data)
  },
}

export default APIKeysService
